<span class="experience__period-range {{ styleType }}">
  {{ duration | durationPeriod : durationType }}
</span>
